import http from "../http/http-config";
import { HealthQuotationResponse } from "../models/healthQuotationResponse";

export default new class HealthQuotationService {
    //Salud Segura Max
    async createHealth321Quotation(model: string): Promise<HealthQuotationResponse> {
        const response = await http.post<HealthQuotationResponse>("GetSafeHealthMaxQuotation", model);
        // Si el backend devuelve 204, lanza un error para que el frontend lo capture
        if (response.status === 204) {
            throw new Error(response.status.toString());
        }
        return response.data;
    }

}
